"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CompCurrClean = void 0;
var react_1 = __importDefault(require("react"));
var CurrSc_1 = require("./CurrSc");
var useInitHome_1 = require("./useInitHome");
var CompCurrClean = function (_a) {
    var infoComp = _a.infoComp;
    var passChanges = infoComp.passChanges, props = infoComp.props;
    var sttSelected = passChanges.sttSelected;
    var info = props.info;
    var infoHome = __assign(__assign({}, info), passChanges);
    (0, useInitHome_1.useInitHome)(infoHome);
    // ----------- set Return
    var newInfo = __assign(__assign({}, info), { passChanges: passChanges });
    return react_1["default"].createElement(react_1["default"].Fragment, null, !!sttSelected && react_1["default"].createElement(CurrSc_1.CurrSc, { info: newInfo }));
};
exports.CompCurrClean = CompCurrClean;
